














import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class HighLightText extends Vue {
  @Prop()
  private language!: string;

  @Prop()
  private allText!: string;

  @Prop()
  private searchText!: string;

  private splitText(): string[] {
    const result: string[] = [];

    if (this.language === 'ja') {
      const words: string[] = this.allText.split(this.searchText);
      for (let i = 0; i < words.length; i++) {
        if (i > 0) {
          result.push(this.searchText);
        }
        if (words[i].length) {
          result.push(words[i]);
        }
      }
    } else if (this.language === 'en') {
      const words: string[] = this.allText.split(' ');
      for (let i = 0; i < words.length; i++) {
        result.push(words[i]);
      }
    }
    return result;
  }

  private includes(searchText: string, word: string): boolean {
    searchText = searchText.toLowerCase();
    word = word.replace(/[.,]/g, '').toLowerCase();

    return searchText.indexOf(word) !== -1;
  }
}
